import React, { Suspense, lazy } from "react";
import Spinner from "components/Spinner";

const CalendarType = lazy(() => import("components/home/CalenderType"));

function Calendar() {
  return (
    <Suspense fallback={<Spinner />}>
      <CalendarType />
    </Suspense>
  );
}

export default Calendar;
